import styled from "styled-components";

export const ContainerCardAllergie = styled.tr`
  background: #f9fafb;
`;

export const IconStyled = styled.img`
  cursor: pointer;
`;
